/**
 * Directive: modalTitle
 */
angular.module('acme.common.directive.modalTitle', [])
.directive('modalTitle', [function() {

    return {
      restrict: 'C',
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
        $element.attr('id', 'modal-title');
      }

    };

}]);
